import { css } from '@emotion/core';
import { srOnly } from '@domain-group/fe-brary';
import { generateStatesColors } from './global';
export var container = /*#__PURE__*/css(generateStatesColors, " border-radius:var(--paginator-border-radius);border-width:var(--paginator-border-width);padding:11px;margin:0 16px;> *{display:block;}> style{display:none;}");
export var label = /*#__PURE__*/css(srOnly);